const rateAndShareModule = {
    initEvents() {
        // Social Sharing
        const title = document.title;
        const url = location.href;

        $('[data-share-social="telegram"]').click(function (e) {
            e.preventDefault();
            window.open('https://t.me/share/url?url=' + encodeURIComponent(url), 'sharer', 'toolbar=0,status=0,width=626,height=436');
        });

        $('[data-share-social="vk"]').click(function (e) {
            e.preventDefault();
            window.open('https://vk.com/share.php?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title), 'sharer', 'toolbar=0,status=0,width=626,height=436');
        });

        $('[data-share-social="facebook"]').click(function (e) {
            e.preventDefault();
            window.open('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title), 'sharer', 'toolbar=0,status=0,width=626,height=436');
        });

        $('[data-share-social="twitter"]').click(function (e) {
            e.preventDefault();
            window.open('https://twitter.com/intent/tweet?' + "&url=" + encodeURIComponent(url) + '&text=' + encodeURIComponent(title), 'MyWindow', 'location=0,status=0,scrollbars=0, width=650,height=300');
        });

        $('[data-share-social="linkedin"]').click(function (e) {
            e.preventDefault();
            window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title) + '&summary=' + '&source=', 'MyWindow', 'location=0,status=0,scrollbars=0, width=650,height=450');
        });

        $('[data-copy]').click(function (e) {
            e.preventDefault();
            navigator.clipboard.writeText(url);
        });

        $('[data-rate-input]').change(function (e) {
            e.preventDefault();
            const postId = e.target.closest('.block-rate-share').dataset.postId;

            const data = {
                action: 'markWidget',
                value: e.target.value,
                postId: postId,
            };

            let alreadyVoted = localStorage.getItem('alreadyVoted');

            if (!alreadyVoted) {
                alreadyVoted = {};
            } else {
                alreadyVoted = JSON.parse(alreadyVoted);
            }
            if (!alreadyVoted[data.postId]) {
                alreadyVoted[data.postId] = data.value;
            } else {
                return false;

            }

            $.post(ajaxurl, data, function (response) {
                response = JSON.parse(response);

                $('[data-avg-mark]').text(Number.parseFloat(response.avgMark).toFixed(1))
                $('[data-count-mark]').text(response.count)
                $('[data-count-text]').text(response.text)


                localStorage.setItem('alreadyVoted', JSON.stringify(alreadyVoted));
                rateAndShareModule.setVote();
            });
        });
    },

    setVote() {
        let alreadyVoted = localStorage.getItem('alreadyVoted');
        const postId = $('[name="post-id"]').attr('content');

        if (alreadyVoted) {
            alreadyVoted = JSON.parse(alreadyVoted);

            if (alreadyVoted[postId]) {
                $('[data-rate-input][value="' + alreadyVoted[postId] + '"]').prop('checked', true);
                $('.full-stars').addClass('full-stars-voted')
                $('[data-rate-input]').prop('disabled', true)
            }
        }

        $('.full-stars').show();
    },

    init() {
        this.initEvents();
        this.setVote();
    }
}

export default rateAndShareModule;
